import React, { Suspense, lazy } from "react";

import { Stack, Typography, useTheme } from "@mui/material";

import { NotInterestedRounded } from "@mui/icons-material";

import { RoundedButton } from "../../Button/RoundedButton";
import { AppDrawerProps, DynamicDrawer } from "../../Drawer/DynamicDrawer";
import { CircularProgressCenter } from "../../Loading/CircularProgressCenter";

const IngredientSearch = lazy(() => import("./IngredientSearch"));

interface IngredientAllergiesDrawerProps extends AppDrawerProps {
  onIngredientsOpen: (value: boolean) => void;
}

export const IngredientAllergiesDrawer = ({
  onIngredientsOpen,
  open,
  onClose,
  containerRef,
}: IngredientAllergiesDrawerProps) => {
  const {
    palette: { oscar },
  } = useTheme();
  return (
    <DynamicDrawer
      ref={containerRef}
      drawerType="small"
      open={open}
      onClose={onClose}
      Header={
        <Stack alignItems="center" gap={1}>
          <NotInterestedRounded sx={{ color: oscar.light.icon.danger }} />
          <Typography variant="headingRLight" textAlign="center">
            Ingredient specific allergies
          </Typography>
        </Stack>
      }
      Footer={<RoundedButton title="Done" onClose={onClose} />}
    >
      <Suspense fallback={<CircularProgressCenter />}>
        <IngredientSearch onViewIngredients={onIngredientsOpen} />
      </Suspense>
    </DynamicDrawer>
  );
};
